import { Capacitor } from '@capacitor/core'
import { Device } from '@capacitor/device'
import { getRandomString } from '../useRandom'

export const getDeviceName = async () => {
  if (!Capacitor.isPluginAvailable('Device')) return `Mon appareil`
  
  const info = await Device.getInfo()

  return `${info.name ?? info.model} ${info.name ? `(${info.model})` : ''}`
}

export const getDeviceId = async () => {
  if (!Capacitor.isPluginAvailable('Device')) return process.client && navigator.userAgent ? navigator.userAgent.toLowerCase().replace(/ /g, '-').replace(/ /g, '-') : getRandomString()

  const id = await Device.getId()

  return id.identifier
}

export const getDeviceLanguage = async () => {
  let foundLanguage = 'fr'
  
  try {
    if (!Capacitor.isPluginAvailable('Device')) {
      foundLanguage = navigator.language ? navigator.language : 'fr'
    } else {
      const info = await Device.getLanguageCode()
      if (info.value) foundLanguage = info.value
    }
  } catch (e) {
    console.error(e)
  }

  return ['fr', 'en'].includes(foundLanguage) ? foundLanguage : 'fr'
}

export const getDeviceInfo = async () => {
  if (!Capacitor.isPluginAvailable('Device')) return null
  
  return await Device.getInfo()
}

export const getDownloadLink = () => {
  const link = ref('')

  const fetch = async () => {
    const deviceInfo = await getDeviceInfo()
    link.value = deviceInfo?.operatingSystem === 'mac' || deviceInfo?.operatingSystem === 'ios' ? `https://apps.apple.com/fr/app/vibes-lgbt-rencontre-sors/id6463439764` : `https://play.google.com/store/apps/details?id=lgbt.vibes.app`
  }

  fetch()

  return {
    link
  }
}
